import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faInstagram,
  faDiscord,
} from "@fortawesome/free-brands-svg-icons";
import {
  faMagnifyingGlass,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";
import SearchModal from "../Search/Search";
import { useAuth } from "../../context/AuthContext";

function Navbar({ logo }) {
  const [showSearch, setShowSearch] = React.useState(false);
  const { currentUser, logout } = useAuth();

  const navbarCollapse = React.useRef(null);

  const handleLinkClick = () => {
    if (navbarCollapse.current) {
      navbarCollapse.current.classList.remove("show");
    }
  };

  return (
    <>
      <SearchModal modalVisible={showSearch} setModalVisible={setShowSearch} />

      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <Link to="/blog" className="navbar-brand" onClick={handleLinkClick}>
          <img src={logo} width="30" height="35" alt="" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {currentUser.authenticated && (
          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
            ref={navbarCollapse}
          >
            <ul className="navbar-nav mr-auto">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Wissen
                </a>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <Link
                    to="knowledge/stock"
                    className="dropdown-item"
                    onClick={handleLinkClick}
                  >
                    Aktienmarkt
                  </Link>
                  <Link
                    to="knowledge/bond"
                    className="dropdown-item"
                    onClick={handleLinkClick}
                  >
                    Anleihen
                  </Link>
                  <Link
                    to="knowledge/crypto"
                    className="dropdown-item"
                    onClick={handleLinkClick}
                  >
                    Krypto & Blockchain
                  </Link>
                  <Link
                    to="knowledge/trading"
                    className="dropdown-item"
                    onClick={handleLinkClick}
                  >
                    Trading
                  </Link>
                </div>
              </li>

              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Tools
                </a>
                <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                  <Link
                    to="tool/cashflow"
                    className="dropdown-item"
                    onClick={handleLinkClick}
                  >
                    Cashflow
                  </Link>
                  <Link
                    to="tool/inflation"
                    className="dropdown-item"
                    onClick={handleLinkClick}
                  >
                    Inflationsrechner
                  </Link>
                  <Link
                    to="tool/roi"
                    className="dropdown-item"
                    onClick={handleLinkClick}
                  >
                    Kapitalrendite
                  </Link>
                  <Link
                    to="tool/compoundinterest"
                    className="dropdown-item"
                    onClick={handleLinkClick}
                  >
                    Zinseszinsrechner
                  </Link>
                </div>
              </li>

              <li className="nav-item">
                <Link to="/book" className="nav-link" onClick={handleLinkClick}>
                  Bücher
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  to="/contact"
                  className="nav-link"
                  onClick={handleLinkClick}
                >
                  Kontakt
                </Link>
              </li>

              {currentUser.authenticated && (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Dein Portfolio
                  </a>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <Link
                      to="portfolio/dashboard"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      Dashboard
                    </Link>
                    <Link
                      to="portfolio/analytics"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      Analyse
                    </Link>
                    <Link
                      to="portfolio/dividend"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      Erträge
                    </Link>
                    <Link
                      to="portfolio/trades"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      Transaktionen
                    </Link>
                    <Link
                      to="portfolio/property"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      Immobilien
                    </Link>
                    <Link
                      to="portfolio/nft"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      NFT
                    </Link>
                    <Link
                      to="portfolio/chatbot"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      Chatbot
                    </Link>
                  </div>
                </li>
              )}

              {currentUser.hasFamily && (
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Familie
                  </a>
                  <div
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <Link
                      to="portfolio/family"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      Analyse
                    </Link>
                    {/* <Link
                      to="portfolio/familybudget"
                      className="dropdown-item"
                      onClick={handleLinkClick}
                    >
                      Haushaltsbuch
                    </Link> */}
                  </div>
                </li>
              )}

              <li className="nav-item">
                <button
                  className="nav-link navbar-search dismiss-active-or-focus"
                  data-toggle="modal"
                  data-target="#searchModal"
                  onClick={() => {
                    handleLinkClick();
                    setShowSearch(true);
                  }}
                >
                  <FontAwesomeIcon icon={faMagnifyingGlass} />
                </button>
              </li>
            </ul>
            <div className="navbar-refIcon">
              {currentUser.authenticated && (
                <ul className="navbar-nav mr-auto">
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {currentUser.name}
                    </a>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="navbarDropdown"
                    >
                      <Link
                        to="/userprofile"
                        className="dropdown-item"
                        onClick={handleLinkClick}
                      >
                        Profil
                      </Link>
                      <Link
                        to="/login"
                        className="dropdown-item"
                        onClick={handleLinkClick}
                      >
                        Logout
                      </Link>
                    </div>
                  </li>
                </ul>
              )}
            </div>
          </div>
        )}
      </nav>
    </>
  );
}

export default Navbar;
